<template>
  <div :class="windowWidth ? 'mainSideBarDiv' : 'mainSideBarMobile'">
    <v-navigation-drawer
      v-if="windowWidth"
      :width="!mini ? '800' : '69'"
      permanent
      class="white-sidebar"
    >
      <div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="mt-3"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
                
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'employers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('employers')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
          
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.33333 13.2333H2.06667C1.78377 13.2333 1.51246 13.3457 1.31242 13.5457C1.11238 13.7457 1 14.017 1 14.2999V17.4999H6.33333V13.2333Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9332 13.2333H11.6665V17.4999H16.9998V14.2999C16.9998 14.017 16.8875 13.7457 16.6874 13.5457C16.4874 13.3457 16.2161 13.2333 15.9332 13.2333Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.6002 8.96667H7.40016C7.11727 8.96667 6.84595 9.07906 6.64592 9.27909C6.44588 9.47913 6.3335 9.75044 6.3335 10.0333V17.5H11.6668V10.0333C11.6668 9.75044 11.5544 9.47913 11.3544 9.27909C11.1544 9.07906 10.8831 8.96667 10.6002 8.96667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.1333 3.36667C7.1333 3.86174 7.32997 4.33653 7.68003 4.6866C8.0301 5.03667 8.5049 5.23333 8.99997 5.23333C9.49504 5.23333 9.96983 5.03667 10.3199 4.6866C10.67 4.33653 10.8666 3.86174 10.8666 3.36667C10.8666 2.8716 10.67 2.3968 10.3199 2.04673C9.96983 1.69667 9.49504 1.5 8.99997 1.5C8.5049 1.5 8.0301 1.69667 7.68003 2.04673C7.32997 2.3968 7.1333 2.8716 7.1333 3.36667V3.36667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3102 6.83336C11.0252 6.49875 10.671 6.23001 10.2719 6.04572C9.87292 5.86143 9.43863 5.76599 8.9991 5.76599C8.55957 5.76599 8.12528 5.86143 7.72626 6.04572C7.32723 6.23001 6.97298 6.49875 6.68799 6.83336"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.8228 8.16672C12.8228 8.66179 13.0194 9.13658 13.3695 9.48665C13.7196 9.83672 14.1943 10.0334 14.6894 10.0334C15.1845 10.0334 15.6593 9.83672 16.0094 9.48665C16.3594 9.13658 16.5561 8.66179 16.5561 8.16672C16.5561 7.67164 16.3594 7.19685 16.0094 6.84678C15.6593 6.49671 15.1845 6.30005 14.6894 6.30005C14.1943 6.30005 13.7196 6.49671 13.3695 6.84678C13.0194 7.19685 12.8228 7.67164 12.8228 8.16672V8.16672Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9998 11.6333C16.616 11.1821 16.1083 10.8533 15.5395 10.6876C14.9708 10.5219 14.3659 10.5266 13.7998 10.7011"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.44385 8.16672C1.44385 8.41185 1.49213 8.65458 1.58594 8.88106C1.67975 9.10753 1.81725 9.31331 1.99058 9.48665C2.16392 9.65998 2.3697 9.79748 2.59617 9.89129C2.82265 9.9851 3.06538 10.0334 3.31051 10.0334C3.55565 10.0334 3.79838 9.9851 4.02486 9.89129C4.25133 9.79748 4.45711 9.65998 4.63045 9.48665C4.80378 9.31331 4.94128 9.10753 5.03509 8.88106C5.1289 8.65458 5.17718 8.41185 5.17718 8.16672C5.17718 7.92158 5.1289 7.67885 5.03509 7.45237C4.94128 7.2259 4.80378 7.02012 4.63045 6.84678C4.45711 6.67345 4.25133 6.53595 4.02486 6.44214C3.79838 6.34833 3.55565 6.30005 3.31051 6.30005C3.06538 6.30005 2.82265 6.34833 2.59617 6.44214C2.3697 6.53595 2.16392 6.67345 1.99058 6.84678C1.81725 7.02012 1.67975 7.2259 1.58594 7.45237C1.49213 7.67885 1.44385 7.92158 1.44385 8.16672V8.16672Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 11.6333C1.28558 11.2995 1.63997 11.0313 2.03887 10.8472C2.43778 10.6631 2.87177 10.5674 3.31111 10.5667C3.61123 10.5669 3.90964 10.6119 4.19644 10.7003"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
                
              "
            >
              Employers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'networks'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('networks')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 4.49219C9.93198 4.49219 10.6875 3.73667 10.6875 2.80469C10.6875 1.87271 9.93198 1.11719 9 1.11719C8.06802 1.11719 7.3125 1.87271 7.3125 2.80469C7.3125 3.73667 8.06802 4.49219 9 4.49219Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.97656 5.52734L7.67156 3.83984"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.0625 7.30469C5.68382 7.30469 6.1875 6.80101 6.1875 6.17969C6.1875 5.55837 5.68382 5.05469 5.0625 5.05469C4.44118 5.05469 3.9375 5.55837 3.9375 6.17969C3.9375 6.80101 4.44118 7.30469 5.0625 7.30469Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.0231 5.52734L10.3281 3.83984"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9375 7.30469C13.5588 7.30469 14.0625 6.80101 14.0625 6.17969C14.0625 5.55837 13.5588 5.05469 12.9375 5.05469C12.3162 5.05469 11.8125 5.55837 11.8125 6.17969C11.8125 6.80101 12.3162 7.30469 12.9375 7.30469Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.81219 16.875L1.30469 15C0.821311 14.4038 0.556635 13.6601 0.554688 12.8925V9.00003C0.554688 8.70166 0.673214 8.41551 0.884192 8.20453C1.09517 7.99355 1.38132 7.87503 1.67969 7.87503V7.87503C1.82805 7.87404 1.97515 7.9024 2.11251 7.9585C2.24987 8.01459 2.37477 8.0973 2.48004 8.20187C2.5853 8.30643 2.66883 8.43078 2.72584 8.56777C2.78284 8.70475 2.81219 8.85165 2.81219 9.00003V11.91"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.18659 16.8736V14.5186C6.187 13.8532 5.9885 13.2029 5.61659 12.6511L4.76159 11.3686C4.6889 11.244 4.59132 11.1357 4.47493 11.0505C4.35853 10.9653 4.22582 10.9049 4.08508 10.8733C3.94433 10.8416 3.79857 10.8393 3.65689 10.8664C3.51521 10.8936 3.38064 10.9497 3.26159 11.0311V11.0311C3.0521 11.1759 2.90237 11.3919 2.84028 11.6389C2.77819 11.8859 2.80798 12.147 2.92409 12.3736L3.93659 14.0611"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.1875 16.875L16.6875 14.985C17.1709 14.3888 17.4356 13.645 17.4375 12.8775V9C17.4375 8.70163 17.319 8.41548 17.108 8.2045C16.897 7.99353 16.6109 7.875 16.3125 7.875C16.0141 7.875 15.728 7.99353 15.517 8.2045C15.306 8.41548 15.1875 8.70163 15.1875 9V11.91"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.8125 16.8736V14.5186C11.8121 13.8532 12.0106 13.2029 12.3825 12.6511L13.2375 11.3686C13.3102 11.244 13.4078 11.1357 13.5242 11.0505C13.6406 10.9653 13.7733 10.9049 13.914 10.8733C14.0548 10.8416 14.2005 10.8393 14.3422 10.8664C14.4839 10.8936 14.6184 10.9497 14.7375 11.0311C14.9495 11.1737 15.1023 11.3887 15.1672 11.6358C15.2321 11.883 15.2047 12.1453 15.09 12.3736L14.0775 14.0611"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              VNets
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'utilization'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('utilization')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.92969 5.42578V9.28292"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.92801 13.7857C10.2831 13.7857 10.5709 13.4979 10.5709 13.1429C10.5709 12.7878 10.2831 12.5 9.92801 12.5C9.57297 12.5 9.28516 12.7878 9.28516 13.1429C9.28516 13.4979 9.57297 13.7857 9.92801 13.7857Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.95495 1.97083L1.97278 8.953C1.43553 9.49025 1.43553 10.3613 1.97278 10.8986L8.95495 17.8807C9.4922 18.418 10.3633 18.418 10.9005 17.8807L17.8827 10.8986C18.4199 10.3613 18.4199 9.49025 17.8827 8.953L10.9005 1.97083C10.3633 1.43358 9.4922 1.43358 8.95495 1.97083Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Utilization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'partners'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('partners')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7824H5.30375L8.11175 18.1551C8.21361 18.3458 8.33692 18.4996 8.47436 18.6073C8.61179 18.7151 8.76054 18.7746 8.91175 18.7824C10.5465 16.7768 12.0823 14.5466 13.5037 12.1142C13.5917 11.6915 13.4238 11.2688 13.2718 10.9143L11.2637 6.49609"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41846H2.6C2.80154 2.41736 2.99589 2.54596 3.14421 2.77855C3.29253 3.01114 3.38388 3.33058 3.4 3.673V12.4275C3.38198 12.7675 3.2898 13.0836 3.14168 13.3133C2.99356 13.5431 2.80027 13.6698 2.6 13.6684H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6684H17.3996C17.1993 13.6698 17.0061 13.5431 16.8579 13.3133C16.7098 13.0836 16.6176 12.7675 16.5996 12.4275V3.673C16.6157 3.33058 16.7071 3.01114 16.8554 2.77855C17.0037 2.54596 17.1981 2.41736 17.3996 2.41846H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
                mt-1
             
              "
            >
              Partners
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'settings' ||
            watchActiveItem == 'settings/account' ||
            watchActiveItem == 'settings/users'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
              @click="activeItem('settings')"
              class="list-item-icon no-padding"
              :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-1 mt-lg-2 mt-md-1' : 'ml-4 mt-xl-1 mt-lg-2 mt-md-1'"
            >
              <svg
                width="16"
                class="pointer mt-3"
                height="16"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.96501 2.19798C8.09556 2.34292 8.25511 2.45881 8.43331 2.53814C8.61151 2.61746 8.80438 2.65845 8.99944 2.65845C9.19449 2.65845 9.38737 2.61746 9.56557 2.53814C9.74377 2.45881 9.90331 2.34292 10.0339 2.19798L10.7069 1.4594C10.8998 1.2459 11.154 1.09733 11.4347 1.03408C11.7153 0.970841 12.0087 0.996024 12.2745 1.10618C12.5403 1.21633 12.7655 1.40605 12.9192 1.64931C13.0729 1.89257 13.1475 2.17743 13.1329 2.46481L13.0824 3.46097C13.0726 3.6553 13.1036 3.84952 13.1735 4.03112C13.2433 4.21272 13.3504 4.37768 13.4879 4.51536C13.6254 4.65304 13.7901 4.7604 13.9716 4.83052C14.1531 4.90064 14.3472 4.93197 14.5415 4.92248L15.5375 4.87196C15.8247 4.8578 16.1092 4.93281 16.3521 5.0867C16.5949 5.24059 16.7843 5.46583 16.8941 5.73155C17.004 5.99728 17.029 6.29048 16.9657 6.57097C16.9024 6.85146 16.754 7.10552 16.5407 7.29832L15.7994 7.96717C15.6546 8.09793 15.5389 8.2576 15.4597 8.43587C15.3805 8.61414 15.3396 8.80704 15.3396 9.00211C15.3396 9.19719 15.3805 9.39009 15.4597 9.56836C15.5389 9.74663 15.6546 9.9063 15.7994 10.0371L16.5407 10.7059C16.7541 10.8988 16.9027 11.1531 16.9659 11.4338C17.0292 11.7145 17.004 12.0079 16.8938 12.2738C16.7837 12.5396 16.594 12.7648 16.3508 12.9185C16.1076 13.0722 15.8227 13.1469 15.5354 13.1323L14.5394 13.0817C14.3447 13.0717 14.15 13.1027 13.968 13.1727C13.786 13.2427 13.6207 13.3501 13.4828 13.488C13.345 13.6259 13.2376 13.7912 13.1676 13.9732C13.0976 14.1552 13.0667 14.3499 13.0767 14.5447L13.1272 15.5408C13.1399 15.8268 13.0644 16.1097 12.9107 16.3512C12.7571 16.5927 12.5329 16.781 12.2685 16.8906C12.0041 17.0002 11.7124 17.0257 11.433 16.9637C11.1537 16.9017 10.9001 16.7552 10.7069 16.5441L10.0374 15.8034C9.90675 15.6587 9.74717 15.5429 9.56898 15.4637C9.3908 15.3846 9.19798 15.3436 9.003 15.3436C8.80801 15.3436 8.61519 15.3846 8.43701 15.4637C8.25882 15.5429 8.09924 15.6587 7.96857 15.8034L7.29626 16.5441C7.10332 16.7562 6.84968 16.9036 6.56991 16.9663C6.29014 17.029 5.99786 17.0038 5.73291 16.8943C5.46795 16.7847 5.24323 16.5961 5.08936 16.3542C4.93549 16.1122 4.85998 15.8287 4.8731 15.5423L4.92433 14.5461C4.93434 14.3513 4.90337 14.1567 4.8334 13.9746C4.76344 13.7926 4.65604 13.6273 4.51817 13.4894C4.38029 13.3515 4.21501 13.2441 4.03301 13.1741C3.851 13.1041 3.65634 13.0732 3.46161 13.0832L2.4656 13.1337C2.17838 13.1487 1.89357 13.0744 1.65025 12.921C1.40694 12.7676 1.21706 12.5427 1.10667 12.2771C0.996293 12.0115 0.970825 11.7182 1.03377 11.4375C1.09671 11.1568 1.24497 10.9025 1.45821 10.7095L2.19881 10.0406C2.34355 9.90986 2.45926 9.75018 2.53845 9.57192C2.61764 9.39365 2.65855 9.20074 2.65855 9.00567C2.65855 8.8106 2.61764 8.6177 2.53845 8.43943C2.45926 8.26116 2.34355 8.10149 2.19881 7.97073L1.45821 7.29832C1.24567 7.1055 1.09785 6.85172 1.03497 6.5717C0.972097 6.29167 0.997222 5.99906 1.10692 5.73385C1.21661 5.46865 1.40552 5.24379 1.64782 5.09003C1.89012 4.93627 2.17399 4.86111 2.46062 4.87481L3.45663 4.92533C3.65173 4.93559 3.8468 4.90469 4.02918 4.83463C4.21156 4.76458 4.37717 4.65694 4.51524 4.51871C4.65332 4.38048 4.76078 4.21474 4.83065 4.03227C4.90051 3.8498 4.93122 3.65466 4.92077 3.45955L4.8731 2.46268C4.85966 2.17611 4.93495 1.89238 5.0887 1.65019C5.24245 1.40801 5.46717 1.21917 5.73219 1.10944C5.99722 0.999708 6.28964 0.974435 6.56955 1.03707C6.84947 1.0997 7.10325 1.24719 7.29626 1.4594L7.96501 2.19798Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.79688 9.00273C5.79688 9.85193 6.13417 10.6664 6.73456 11.2668C7.33495 11.8673 8.14926 12.2047 8.99834 12.2047C9.84742 12.2047 10.6617 11.8673 11.2621 11.2668C11.8625 10.6664 12.1998 9.85193 12.1998 9.00273C12.1998 8.15352 11.8625 7.33909 11.2621 6.73861C10.6617 6.13813 9.84742 5.80078 8.99834 5.80078C8.14926 5.80078 7.33495 6.13813 6.73456 6.73861C6.13417 7.33909 5.79688 8.15352 5.79688 9.00273V9.00273Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'settings' ||
                watchActiveItem == 'settings/account' ||
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('settings')"
              class="text-gray-darker"
              >Settings
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'settings/account'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-0"
              @click="activeItem('settings/account')"
            >
              Account
            </div>

            <div
              :class="
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-1 ml-2"
              @click="activeItem('settings/users')"
            >
              Users
            </div>
          </div>
        </v-list-group>
      </div>
      <div>
        <v-divider></v-divider>
        <v-list-item two-line v-if="!mini" class="mb-2">
          <span class="orange--text mt-1 ml-1" style="font-size: 9px">
            Powered by:
          </span>

          <v-list-item-content
            class="no-padding pointer justify-center mt-2 mb-2"
          >
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img src="/apalyhealthlogo.png" alt="" class="mt-1 ml-1" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line v-else class="mt-4">
          <v-list-item-content class="no-padding pointer">
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img
                src="/apaly1.png"
                class="ml-1"
                width="95"
                height="45"
                alt=""
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>
    <!-- Mobile -->
    <v-navigation-drawer v-else permanent class="white-sidebar-onmobile mt-3">
      <div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="mt-3"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'employers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('employers')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.33333 13.2333H2.06667C1.78377 13.2333 1.51246 13.3457 1.31242 13.5457C1.11238 13.7457 1 14.017 1 14.2999V17.4999H6.33333V13.2333Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9332 13.2333H11.6665V17.4999H16.9998V14.2999C16.9998 14.017 16.8875 13.7457 16.6874 13.5457C16.4874 13.3457 16.2161 13.2333 15.9332 13.2333Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.6002 8.96667H7.40016C7.11727 8.96667 6.84595 9.07906 6.64592 9.27909C6.44588 9.47913 6.3335 9.75044 6.3335 10.0333V17.5H11.6668V10.0333C11.6668 9.75044 11.5544 9.47913 11.3544 9.27909C11.1544 9.07906 10.8831 8.96667 10.6002 8.96667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.1333 3.36667C7.1333 3.86174 7.32997 4.33653 7.68003 4.6866C8.0301 5.03667 8.5049 5.23333 8.99997 5.23333C9.49504 5.23333 9.96983 5.03667 10.3199 4.6866C10.67 4.33653 10.8666 3.86174 10.8666 3.36667C10.8666 2.8716 10.67 2.3968 10.3199 2.04673C9.96983 1.69667 9.49504 1.5 8.99997 1.5C8.5049 1.5 8.0301 1.69667 7.68003 2.04673C7.32997 2.3968 7.1333 2.8716 7.1333 3.36667V3.36667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3102 6.83336C11.0252 6.49875 10.671 6.23001 10.2719 6.04572C9.87292 5.86143 9.43863 5.76599 8.9991 5.76599C8.55957 5.76599 8.12528 5.86143 7.72626 6.04572C7.32723 6.23001 6.97298 6.49875 6.68799 6.83336"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.8228 8.16672C12.8228 8.66179 13.0194 9.13658 13.3695 9.48665C13.7196 9.83672 14.1943 10.0334 14.6894 10.0334C15.1845 10.0334 15.6593 9.83672 16.0094 9.48665C16.3594 9.13658 16.5561 8.66179 16.5561 8.16672C16.5561 7.67164 16.3594 7.19685 16.0094 6.84678C15.6593 6.49671 15.1845 6.30005 14.6894 6.30005C14.1943 6.30005 13.7196 6.49671 13.3695 6.84678C13.0194 7.19685 12.8228 7.67164 12.8228 8.16672V8.16672Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9998 11.6333C16.616 11.1821 16.1083 10.8533 15.5395 10.6876C14.9708 10.5219 14.3659 10.5266 13.7998 10.7011"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.44385 8.16672C1.44385 8.41185 1.49213 8.65458 1.58594 8.88106C1.67975 9.10753 1.81725 9.31331 1.99058 9.48665C2.16392 9.65998 2.3697 9.79748 2.59617 9.89129C2.82265 9.9851 3.06538 10.0334 3.31051 10.0334C3.55565 10.0334 3.79838 9.9851 4.02486 9.89129C4.25133 9.79748 4.45711 9.65998 4.63045 9.48665C4.80378 9.31331 4.94128 9.10753 5.03509 8.88106C5.1289 8.65458 5.17718 8.41185 5.17718 8.16672C5.17718 7.92158 5.1289 7.67885 5.03509 7.45237C4.94128 7.2259 4.80378 7.02012 4.63045 6.84678C4.45711 6.67345 4.25133 6.53595 4.02486 6.44214C3.79838 6.34833 3.55565 6.30005 3.31051 6.30005C3.06538 6.30005 2.82265 6.34833 2.59617 6.44214C2.3697 6.53595 2.16392 6.67345 1.99058 6.84678C1.81725 7.02012 1.67975 7.2259 1.58594 7.45237C1.49213 7.67885 1.44385 7.92158 1.44385 8.16672V8.16672Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 11.6333C1.28558 11.2995 1.63997 11.0313 2.03887 10.8472C2.43778 10.6631 2.87177 10.5674 3.31111 10.5667C3.61123 10.5669 3.90964 10.6119 4.19644 10.7003"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Employers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'networks'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('networks')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-5' : 'ml-4 mt-5'"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 4.49219C9.93198 4.49219 10.6875 3.73667 10.6875 2.80469C10.6875 1.87271 9.93198 1.11719 9 1.11719C8.06802 1.11719 7.3125 1.87271 7.3125 2.80469C7.3125 3.73667 8.06802 4.49219 9 4.49219Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.97656 5.52734L7.67156 3.83984"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.0625 7.30469C5.68382 7.30469 6.1875 6.80101 6.1875 6.17969C6.1875 5.55837 5.68382 5.05469 5.0625 5.05469C4.44118 5.05469 3.9375 5.55837 3.9375 6.17969C3.9375 6.80101 4.44118 7.30469 5.0625 7.30469Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.0231 5.52734L10.3281 3.83984"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9375 7.30469C13.5588 7.30469 14.0625 6.80101 14.0625 6.17969C14.0625 5.55837 13.5588 5.05469 12.9375 5.05469C12.3162 5.05469 11.8125 5.55837 11.8125 6.17969C11.8125 6.80101 12.3162 7.30469 12.9375 7.30469Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.81219 16.875L1.30469 15C0.821311 14.4038 0.556635 13.6601 0.554688 12.8925V9.00003C0.554688 8.70166 0.673214 8.41551 0.884192 8.20453C1.09517 7.99355 1.38132 7.87503 1.67969 7.87503V7.87503C1.82805 7.87404 1.97515 7.9024 2.11251 7.9585C2.24987 8.01459 2.37477 8.0973 2.48004 8.20187C2.5853 8.30643 2.66883 8.43078 2.72584 8.56777C2.78284 8.70475 2.81219 8.85165 2.81219 9.00003V11.91"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.18659 16.8736V14.5186C6.187 13.8532 5.9885 13.2029 5.61659 12.6511L4.76159 11.3686C4.6889 11.244 4.59132 11.1357 4.47493 11.0505C4.35853 10.9653 4.22582 10.9049 4.08508 10.8733C3.94433 10.8416 3.79857 10.8393 3.65689 10.8664C3.51521 10.8936 3.38064 10.9497 3.26159 11.0311V11.0311C3.0521 11.1759 2.90237 11.3919 2.84028 11.6389C2.77819 11.8859 2.80798 12.147 2.92409 12.3736L3.93659 14.0611"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.1875 16.875L16.6875 14.985C17.1709 14.3888 17.4356 13.645 17.4375 12.8775V9C17.4375 8.70163 17.319 8.41548 17.108 8.2045C16.897 7.99353 16.6109 7.875 16.3125 7.875C16.0141 7.875 15.728 7.99353 15.517 8.2045C15.306 8.41548 15.1875 8.70163 15.1875 9V11.91"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.8125 16.8736V14.5186C11.8121 13.8532 12.0106 13.2029 12.3825 12.6511L13.2375 11.3686C13.3102 11.244 13.4078 11.1357 13.5242 11.0505C13.6406 10.9653 13.7733 10.9049 13.914 10.8733C14.0548 10.8416 14.2005 10.8393 14.3422 10.8664C14.4839 10.8936 14.6184 10.9497 14.7375 11.0311C14.9495 11.1737 15.1023 11.3887 15.1672 11.6358C15.2321 11.883 15.2047 12.1453 15.09 12.3736L14.0775 14.0611"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              VNets
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'utilization'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('utilization')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-5'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.92969 5.42578V9.28292"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.92801 13.7857C10.2831 13.7857 10.5709 13.4979 10.5709 13.1429C10.5709 12.7878 10.2831 12.5 9.92801 12.5C9.57297 12.5 9.28516 12.7878 9.28516 13.1429C9.28516 13.4979 9.57297 13.7857 9.92801 13.7857Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.95495 1.97083L1.97278 8.953C1.43553 9.49025 1.43553 10.3613 1.97278 10.8986L8.95495 17.8807C9.4922 18.418 10.3633 18.418 10.9005 17.8807L17.8827 10.8986C18.4199 10.3613 18.4199 9.49025 17.8827 8.953L10.9005 1.97083C10.3633 1.43358 9.4922 1.43358 8.95495 1.97083Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Utilization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'partners'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('partners')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7824H5.30375L8.11175 18.1551C8.21361 18.3458 8.33692 18.4996 8.47436 18.6073C8.61179 18.7151 8.76054 18.7746 8.91175 18.7824C10.5465 16.7768 12.0823 14.5466 13.5037 12.1142C13.5917 11.6915 13.4238 11.2688 13.2718 10.9143L11.2637 6.49609"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41846H2.6C2.80154 2.41736 2.99589 2.54596 3.14421 2.77855C3.29253 3.01114 3.38388 3.33058 3.4 3.673V12.4275C3.38198 12.7675 3.2898 13.0836 3.14168 13.3133C2.99356 13.5431 2.80027 13.6698 2.6 13.6684H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6684H17.3996C17.1993 13.6698 17.0061 13.5431 16.8579 13.3133C16.7098 13.0836 16.6176 12.7675 16.5996 12.4275V3.673C16.6157 3.33058 16.7071 3.01114 16.8554 2.77855C17.0037 2.54596 17.1981 2.41736 17.3996 2.41846H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Partners
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'settings'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
            class="list-item-icon no-padding  ml-4  ml-md-1 mt-1"
            >
              <svg
                width="18"
                class="pointer mt-3"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.96501 2.19798C8.09556 2.34292 8.25511 2.45881 8.43331 2.53814C8.61151 2.61746 8.80438 2.65845 8.99944 2.65845C9.19449 2.65845 9.38737 2.61746 9.56557 2.53814C9.74377 2.45881 9.90331 2.34292 10.0339 2.19798L10.7069 1.4594C10.8998 1.2459 11.154 1.09733 11.4347 1.03408C11.7153 0.970841 12.0087 0.996024 12.2745 1.10618C12.5403 1.21633 12.7655 1.40605 12.9192 1.64931C13.0729 1.89257 13.1475 2.17743 13.1329 2.46481L13.0824 3.46097C13.0726 3.6553 13.1036 3.84952 13.1735 4.03112C13.2433 4.21272 13.3504 4.37768 13.4879 4.51536C13.6254 4.65304 13.7901 4.7604 13.9716 4.83052C14.1531 4.90064 14.3472 4.93197 14.5415 4.92248L15.5375 4.87196C15.8247 4.8578 16.1092 4.93281 16.3521 5.0867C16.5949 5.24059 16.7843 5.46583 16.8941 5.73155C17.004 5.99728 17.029 6.29048 16.9657 6.57097C16.9024 6.85146 16.754 7.10552 16.5407 7.29832L15.7994 7.96717C15.6546 8.09793 15.5389 8.2576 15.4597 8.43587C15.3805 8.61414 15.3396 8.80704 15.3396 9.00211C15.3396 9.19719 15.3805 9.39009 15.4597 9.56836C15.5389 9.74663 15.6546 9.9063 15.7994 10.0371L16.5407 10.7059C16.7541 10.8988 16.9027 11.1531 16.9659 11.4338C17.0292 11.7145 17.004 12.0079 16.8938 12.2738C16.7837 12.5396 16.594 12.7648 16.3508 12.9185C16.1076 13.0722 15.8227 13.1469 15.5354 13.1323L14.5394 13.0817C14.3447 13.0717 14.15 13.1027 13.968 13.1727C13.786 13.2427 13.6207 13.3501 13.4828 13.488C13.345 13.6259 13.2376 13.7912 13.1676 13.9732C13.0976 14.1552 13.0667 14.3499 13.0767 14.5447L13.1272 15.5408C13.1399 15.8268 13.0644 16.1097 12.9107 16.3512C12.7571 16.5927 12.5329 16.781 12.2685 16.8906C12.0041 17.0002 11.7124 17.0257 11.433 16.9637C11.1537 16.9017 10.9001 16.7552 10.7069 16.5441L10.0374 15.8034C9.90675 15.6587 9.74717 15.5429 9.56898 15.4637C9.3908 15.3846 9.19798 15.3436 9.003 15.3436C8.80801 15.3436 8.61519 15.3846 8.43701 15.4637C8.25882 15.5429 8.09924 15.6587 7.96857 15.8034L7.29626 16.5441C7.10332 16.7562 6.84968 16.9036 6.56991 16.9663C6.29014 17.029 5.99786 17.0038 5.73291 16.8943C5.46795 16.7847 5.24323 16.5961 5.08936 16.3542C4.93549 16.1122 4.85998 15.8287 4.8731 15.5423L4.92433 14.5461C4.93434 14.3513 4.90337 14.1567 4.8334 13.9746C4.76344 13.7926 4.65604 13.6273 4.51817 13.4894C4.38029 13.3515 4.21501 13.2441 4.03301 13.1741C3.851 13.1041 3.65634 13.0732 3.46161 13.0832L2.4656 13.1337C2.17838 13.1487 1.89357 13.0744 1.65025 12.921C1.40694 12.7676 1.21706 12.5427 1.10667 12.2771C0.996293 12.0115 0.970825 11.7182 1.03377 11.4375C1.09671 11.1568 1.24497 10.9025 1.45821 10.7095L2.19881 10.0406C2.34355 9.90986 2.45926 9.75018 2.53845 9.57192C2.61764 9.39365 2.65855 9.20074 2.65855 9.00567C2.65855 8.8106 2.61764 8.6177 2.53845 8.43943C2.45926 8.26116 2.34355 8.10149 2.19881 7.97073L1.45821 7.29832C1.24567 7.1055 1.09785 6.85172 1.03497 6.5717C0.972097 6.29167 0.997222 5.99906 1.10692 5.73385C1.21661 5.46865 1.40552 5.24379 1.64782 5.09003C1.89012 4.93627 2.17399 4.86111 2.46062 4.87481L3.45663 4.92533C3.65173 4.93559 3.8468 4.90469 4.02918 4.83463C4.21156 4.76458 4.37717 4.65694 4.51524 4.51871C4.65332 4.38048 4.76078 4.21474 4.83065 4.03227C4.90051 3.8498 4.93122 3.65466 4.92077 3.45955L4.8731 2.46268C4.85966 2.17611 4.93495 1.89238 5.0887 1.65019C5.24245 1.40801 5.46717 1.21917 5.73219 1.10944C5.99722 0.999708 6.28964 0.974435 6.56955 1.03707C6.84947 1.0997 7.10325 1.24719 7.29626 1.4594L7.96501 2.19798Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.79688 9.00273C5.79688 9.85193 6.13417 10.6664 6.73456 11.2668C7.33495 11.8673 8.14926 12.2047 8.99834 12.2047C9.84742 12.2047 10.6617 11.8673 11.2621 11.2668C11.8625 10.6664 12.1998 9.85193 12.1998 9.00273C12.1998 8.15352 11.8625 7.33909 11.2621 6.73861C10.6617 6.13813 9.84742 5.80078 8.99834 5.80078C8.14926 5.80078 7.33495 6.13813 6.73456 6.73861C6.13417 7.33909 5.79688 8.15352 5.79688 9.00273V9.00273Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'settings'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('settings')"
              class="text-gray-darker"
              >Settings
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'settings/account'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer"
              @click="activeItem('settings/account')"
            >
              Account
            </div>

            <div
              :class="
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-2"
              @click="activeItem('settings/users')"
            >
              Users
            </div>
          </div>
        </v-list-group>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "Tables",
  data() {
    return {
      miniVersion: true,
      item: "home",
      items: [
        {
          icon: "fas fa-home",
          title: "Home",
        },
        {
          icon: "fas fa-users",
          title: "Clients",
        },
        {
          icon: "fas fa-cog",
          title: "Settings",
        },
      ],
      route: this.$route.path,
    };
  },
  props: {
    windowWidth: {
      type: Boolean,
    },
    mini: {
      type: Boolean,
    },
  },

  computed: {
    routeParams() {
      return this.$route.params.name;
    },
    path() {
      return this.$route.path.replace(/%20/g, " ");
    },
    watchActiveItem() {
      if (
        this.$route.path.includes(
          `/employer-advisor/employers/${this.routeParams}`
        )
      ) {
        this.item = "employers";
      } else if (
        this.$route.path.includes("/employer-advisor/settings/users")
      ) {
        this.item = "settings/users";
      } else if (
        this.$route.path.includes("/employer-advisor/settings/account")
      ) {
        this.item = "settings/account";
      } else if (
        this.$route.path.includes("/employer-advisor/wizard-form")
      ) {
        this.item = "home";
      } else if (this.$route.path.includes(this.$route.path.split("/")[2])) {
        this.item = this.$route.path.split("/")[2];
      }

      return this.item;
    },
  },
  created() {},
  methods: {
    activeItem(tab) {
      if (this.$route.path != `/employer-advisor/${tab}`) {
        this.$router.push(`/employer-advisor/${tab}`);
      }
      if (!this.windowWidth) {
        this.$emit("closeSideBar");
      }
    },
  },
};
</script>
<style lang="scss">
.active,
.inactive {
  min-height: 10px !important;
  max-height: 45px;
}
.active-settings {
  color: #109cf1 !important;
}
.icons-margin-top {
  margin-top: 20px;
}
.active-settings > .v-list-item__content > .v-list-item__title {
  color: #109cf1 !important;
}
.active-settings > .v-list-item > .v-list-item__icon > svg > path {
  fill: none;
  stroke: #109cf1 !important;
}
.theme--light.v-list-item:hover::before {
  opacity: 0 !important;
}
.inactive:hover {
  background: white !important;

  .v-list-item__content {
    .v-list-item__title {
      color: #109cf1 !important;
    }
  }
  .v-list-item__icon {
    svg {
      color: #109cf1 !important;
      path {
        color: #109cf1 !important;
        stroke: #109cf1 !important;
      }
    }
  }
}
</style>
